var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative text-center edit-container m-auto"},[_c('input',{staticClass:"d-none",attrs:{"id":"file-upload","type":"file","accept":"image/*"},on:{"change":_vm.onChange}}),_c('label',{staticClass:"text-center p-2 custom-avatar pointer-cursor m-0 font-weight-bold",attrs:{"for":"file-upload"}},[_vm._v(" Edit ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }